import { render, staticRenderFns } from "./PublishForm.vue?vue&type=template&id=105ae050"
import script from "./PublishForm.vue?vue&type=script&lang=js"
export * from "./PublishForm.vue?vue&type=script&lang=js"
import style0 from "./PublishForm.vue?vue&type=style&index=0&id=105ae050&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports